<template>
    <div class="index-img-wrap" :class="getClass(item.style)" :style="[{'margin-top': widthScale * item.marginTop + 'px' || 0},{'margin-bottom': widthScale * item.marginBottom + 'px' || 0},{'background-image':'url('+item.baseImageUrl+')'},{'margin-left':(item.style==1)&&(widthScale * item.imageMarginWidth + 'px')},{'margin-right':(item.style==1)&&(widthScale * item.imageMarginWidth + 'px')}]">
        <div class="img-list">
            <div class="item-box" v-for="(e, i) in item.itemList" :key="i"> 
                <img
                 class="inline-block"
                 :style="{ width: imgWidth }"
                 :src="e.imgUrl + (/\.(gif)$/.test(e.imgUrl) ? '' : '?x-oss-process=style/style_index_banner')"
                 @click="toNewLink(e)"
                 alt=""
                >
                <span v-if="imgSpace && i < item.itemList.length - 1" class="inline-block" :style="{ width: imgSpace }"></span>
            </div>
        </div>
    </div>
</template>

<script>
import utils from '@/utils/common';
import http from "@/utils/axios";
export default {
    props: {
        contentPageId: {
            default: 0,
            type: Number
        },
        item: {
            type: Object,
            default: function() {
                return {}
            }
        },
        sort: {
            default: 0,
            type: Number
        },
        isExposure: {
            default: true,
            type: Boolean
        },
        pageCode:{
            default:'',
            type:[Number, String]
        }
    },
    data() {
        return {
            widthScale:  window.innerWidth / 750,
            imgWidth: '',
            imgSpace: 0,
        }
    },
    watch: {
        item: {
            immediate: true,
            handler(newVal) {
                if(newVal && (newVal.itemList || []).length) {
                    const style = newVal.style == 8 ? 4 : newVal.style
                    const LEFT_AND_RIGHT_MARGIN = 60
                    const SUM_SPACE = (style - 1) * newVal.imgSpace
                    
                    switch(style) {
                        case 1:
                            this.imgWidth = '100%'
                            break;
                        case 2:
                        case 3:
                        case 4:
                            const width = (750 - LEFT_AND_RIGHT_MARGIN - SUM_SPACE) / style 
                            this.imgWidth =  this.toPx(width)
                            break;
                        case 9:
                            this.imgWidth = this.toPx(230)               
                    }
                    this.imgSpace = this.toPx(newVal.imgSpace)
                }
            }
        }
    },
    mounted() {
        gio("track", "moduleExposure", {indexId_var: String(this.contentPageId), entryType_vara:this.item.title, entryType_floor_var: String(this.sort)});
    },
    methods: {
        getClass(style) {
            let styles = '';
            switch(style) {
                case 1:
                    styles = 'list-one';
                    break;
                case 2:
                    styles = 'list-two';
                    break;
                case 3:
                    styles = 'list-three';
                    break;
                case 8:
                    styles = 'list-four';
                    break;
                default:
                    styles = 'list-more';
                    break;
            }
            return styles;
        },
        toNewLink(item, index) {
            if(this.item.configType == 1) {
                this.toNormalLink(item, index)
            } else {
                this.toAdPositionLink(item, index)
            }   
        },
        //固定跳转
        toNormalLink(item, index) {
            gio("track", "flowLocationClick", {indexId_var: String(this.contentPageId), entryType_vara:this.item.title, entryType_floor_var: String(this.sort), position_var:String(index), sort_var:'', positonName_var:item.name});
            switch(item.linkType) {
                // 不跳转
                case 1: 
                    break;
                // 链接
                case 2: 
                    if (item.linkValue) {
                        let params = {}
                        item.linkValue.split('?')[1] && item.linkValue.split('?')[1].split('&').forEach(item => {
                            let strArr = item.split('=');
                            params[strArr[0]] = strArr[1];
                        });
                        utils.jumpToNewPage({
                            url: item.linkValue,
                            barColor: params.naviBarColor && '#' + params.naviBarColor
                        });
                    }
                    break;
                // 商品
                case 3: 
                    // this.$router.push({
                    //     path: "/commoditydetails",
                    //     query: { id: item.linkValue }
                    // });
                    let obj = {goodsId:parseInt(item.linkValue)};

                    utils.jumpToNewPage({
                        url: window.location.origin + "/h5user/commoditydetails?id=" +  item.linkValue,
                        noTitle: "0",
                        action:{tm:"4030100",tp:obj}
                    });

                    break;
                // 店铺
                case 4: 
                    utils.jumpToNewPage({
                        url: window.location.origin +'/h5user/brandindex?id=' + item.linkValue,
                        noTitle: '1',
                        action:{tm:"4090100",tp:{branchId:parseInt(item.linkValue)}}
                    });
                    break;
                // 发现话题
                case 5: 
                    utils.jumpToNewPage({
                        url: window.location.origin +'/h5user/discoverHottopic?hotId=' + item.linkValue,
                        noTitle: '0'
                    });
                    break;
                // 我的蜜蜂
                case 6: 
                    this.$minicode.show({pageCode:this.pageCode,pageQueryParam:this.$route.query,isShow:'为了您有更好的体验，请您下载APP 或打开小程序'});
                    utils.jumpBeeLists()
                    break;
                // 发现
                case 7: 
                    this.$router.push({name: 'discoverUserDetails', query: { discoverId: item.linkValue}})
                    break;
                // 店铺图集
                case 8: 
                    utils.jumpToNewPage({
                        url: window.location.origin +'/h5user/atlasDetail?brandId=' + item.branchId + '&atlasId=' + item.branchAtlasId,
                        noTitle: '1'
                    });
                    break;
                //品牌主页    
                case 9:
                    utils.jumpToNewPage({
                        url: window.location.origin + "/h5user/strollbrand",
                        noTitle: "1",
                    })
                    break;
                //品牌详情  
                case 10:
                    utils.jumpToNewPage({
                        url: window.location.origin + '/h5user/brandlist?id=' + item.linkValue,
                        noTitle: "1"
                    })
                    break;    
                default: 
                    break;
            }
            utils.nativeMethod({tm:'4000101',tp:{module_evar:this.item.title}})
        },
        // 广告跳转
        toAdPositionLink(item, index) {
            gio("track", "flowLocationClick", {positonName_var:item.name+'---'+item.refId});
            switch(item.linkType) {
                // 不跳转
                case 1: 
                    break;
                // 链接
                case 2: 
                    if (item.linkValue) {
                        let params = {}
                        item.linkValue.split('?')[1] && item.linkValue.split('?')[1].split('&').forEach(item => {
                            let strArr = item.split('=');
                            params[strArr[0]] = strArr[1];
                        });
                        utils.jumpToNewPage({
                            url: item.linkValue,
                            barColor: params.naviBarColor && '#' + params.naviBarColor
                        });
                    }
                    break;
                // 商品
                case 3: 
                    // this.$router.push({
                    //     path: "/commoditydetails",
                    //     query: { id: item.linkValue }
                    // });
                        var obj = {goodsId:parseInt(item.linkValue)};
                utils.jumpToNewPage({
                    url: window.location.origin + "/h5user/commoditydetails?id=" +  item.linkValue,
                    noTitle: "0",
                    action:{tm:"4030100",tp:obj}
                });

                    break;
                // 店铺
                case 4: 
                    utils.jumpToNewPage({
                        url: window.location.origin +'/h5user/brandindex?id=' + item.linkValue,
                        noTitle: '1',
                         action:{tm:"4090100",tp:{branchId:parseInt(item.linkValue)}}
                    });
                    break;
                // 发现话题
                case 5: 
                    utils.jumpToNewPage({
                        url: window.location.origin +'/h5user/discoverHottopic?hotId=' + item.linkValue,
                        noTitle: '0'
                    });
                    break;
                // 发现
                case 6: 
                    this.$router.push({name: 'discoverUserDetails', query: { discoverId: item.linkValue}})
                    break;
                default: 
                    break;
            }
            // utils.nativeMethod({tm:'4000101',tp:{module_evar:this.item.title}})
            if(this.isExposure) {
                this.onAdPositionClick(item.refId)
            }
        },
        onAdPositionClick(refId) {
            http({
                url: '/order/app/ad-position/onClick/' + refId,
                method: "post"
            })
        },
        toPx(v) {
            v = Number(v);
            if(isNaN(v)) return v;
            const windowWidth = document.documentElement.clientWidth || document.body.clientWidth;
            const scale = windowWidth / 750;
            const eps = 1e-4;
            return Math.floor(v * scale + eps) + 'px';
        }
    }
}
</script>

<style lang="less" scoped>
.index-img-wrap {
    margin: 0 30px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: block;
    .img-list {
        white-space: nowrap;
        font-size: 0;
        .item-box, .inline-block {
            display: inline-block;
        }
    }
}
.index-img-wrap.list-more {
    .img-list {
        overflow-x: auto;
        &::-webkit-scrollbar {display:none}
    }
    .img {
        width: 230px;
        display: inline-block;
    }
}
</style>